export interface IRefDocumentReceptionStatus {
  code?: number;
  dataModelAttribute?: string;
  longLabel?: boolean;
}

export interface IRefDocumentType {
  code?: number;
  dataModelAttribute?: string;
  longLabel?: boolean;
}

export interface IRefDocument {
  code?: number;
  longLabel?: string;
  refDocumentType?: IRefDocumentType;
}

export interface IDocumentClient {
  blobCode?: string;
  comment?: string;
  description?: string;
  refDocument?: IRefDocument;
  refDocumentReceptionStatus?: IRefDocumentReceptionStatus;
}

export interface IDocument {
  subscriptionNumber?: string;
  claimNumber?: string;
  content?: string;
  refDocumentCode?: number;
  userName?: string;
  refDataTypeCode: string;
  createTask: boolean;
}

export class DocumentModel {
  documentSelected?: any;
  documentList?: any;
  productOffer?: any;
}
